import { RadioSticky } from "./radio-sticky";

export class RadioInsetBrightcove {
    constructor() {
        this.init();
    };

    init() {
        this.showDuration();
    }

    // Trapi para mostrar de inicio el tiempo total del audio de Brightcove
    showDuration() {
        const radioInset = $(".radio-inset-brightcove");
        if (!radioInset.length) {
            return;
        }

        const videoJs = radioInset.find(".video-js");
        if (!videoJs.length) {
            return;
        }

        const currentTime = videoJs.find(".vjs-current-time");
        if (!currentTime.length) {
            return;
        }

        const duration = videoJs.find(".vjs-duration");
        if (!duration.length) {
            return;
        }

        const playButton = videoJs.find(".vjs-play-control");
        if (!playButton.length) {
            return;
        }

        playButton.click(() => {
            this.clickOrTouchEvent(duration, currentTime, radioInset);
        });

        playButton[0].addEventListener('touchend', () => {
            this.clickOrTouchEvent(duration, currentTime, radioInset);
        });
    }

    clickOrTouchEvent(duration, currentTime, radioInset) {
        duration.hide();
        currentTime.show();

        const radioSubbody = radioInset.find(".radio-inset__subbody");
        if (radioSubbody.length > 0) {
            new RadioSticky(radioSubbody.first());
        }
    }
}
